import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllYoutubeCmsEstimateAssets.graphql';
import { Query, QueryallYoutubeCmsEstimateAssetsArgs } from '../../__generated__/globalTypes';

export const useAllYoutubeCmsEstimateAssetsQuery = (
  options?: QueryHookOptions<Query, QueryallYoutubeCmsEstimateAssetsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallYoutubeCmsEstimateAssetsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllYoutubeCmsEstimateAssetsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallYoutubeCmsEstimateAssetsArgs>
): QueryResult<Query, QueryallYoutubeCmsEstimateAssetsArgs> & {
  getAllYoutubeCmsEstimateAssets: LazyQueryExecFunction<Query, QueryallYoutubeCmsEstimateAssetsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllYoutubeCmsEstimateAssets, result] = useLazyQuery<Query, QueryallYoutubeCmsEstimateAssetsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllYoutubeCmsEstimateAssets, ...result };
};

export const useAllYoutubeCmsEstimateAssetsPromiseQuery = () => {
  const client = useApolloClient();

  const getAllYoutubeCmsEstimateAssets = useCallback(
    (options?: Omit<QueryOptions<QueryallYoutubeCmsEstimateAssetsArgs, Query>, 'query'>) =>
      client.query<Query, QueryallYoutubeCmsEstimateAssetsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllYoutubeCmsEstimateAssets };
};
// Suspense Query Hooks
export const useAllYoutubeCmsEstimateAssetsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallYoutubeCmsEstimateAssetsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallYoutubeCmsEstimateAssetsArgs>(QUERY, {
    ...options
  });

  return result;
};
